import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { BillDynamicGroupablesUpdateValidationSchema } from '../../schemas/billDynamicGroupables/update.schema'

type UseUpsertBillDynamicGroupablesProps = {
  companyId?: string;
  groupsToDelete: { id: string; _destroy: boolean; }[];
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useUpsertBillDynamicGroupables = ({
  companyId,
  groupsToDelete,
  onSuccess,
  onError,
}: UseUpsertBillDynamicGroupablesProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['upsertBillDynamicGroupables', companyId],
    mutationFn: async (form: BillDynamicGroupablesUpdateValidationSchema) => {
      const payload = {
        groupable_attributes: [
          ...groupsToDelete,
          ...form.groupable.map((group) => ({
            id: group.id || undefined,
            category_ids: group.categories.map(({ value }) => value),
            product_ids: group.products.map(({ value }) => value),
          }))
        ],
      }

      return privateAxios.put(`/client/companies/${companyId}/upsert_bill_dynamic_groupables`, payload);
    },
    onSuccess,
    onError,
  })
}
